import { ThemeEvents } from '@theme/events';

class LunowiaDeliveryStatus extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  updateStatus = (event) => {
    if (event.detail.data.productId !== this.dataset.productId && !event.detail.data.newProduct) return;

    const selector = `lunowia-delivery-status[data-product-id="${this.dataset.productId}"]`;
    const nextStatus = event.detail.data.html.querySelector(selector);
    if (!nextStatus) return;

    this.dataset.available = nextStatus.dataset.available;
    this.toggleAttribute('hidden', nextStatus.hasAttribute('hidden'));
    this.replaceChildren(...nextStatus.cloneNode(true).childNodes);
  };
}

if (!customElements.get('lunowia-delivery-status')) {
  customElements.define('lunowia-delivery-status', LunowiaDeliveryStatus);
}
